import { Controller } from "@hotwired/stimulus"

// Toggles contract file upload when "generate PDF after save" is checked (admin new subscriber).
export default class extends Controller {
  static targets = ["toggle", "uploadSection"]

  connect() {
    this.refresh()
  }

  refresh() {
    if (!this.hasUploadSectionTarget) return

    if (!this.hasToggleTarget) {
      this.uploadSectionTarget.classList.remove("d-none")
      this.#setFileInputDisabled(false)
      return
    }

    const generateInstead = this.toggleTarget.checked
    this.uploadSectionTarget.classList.toggle("d-none", generateInstead)
    this.#setFileInputDisabled(generateInstead)
  }

  #setFileInputDisabled(disabled) {
    const input = this.uploadSectionTarget.querySelector('input[type="file"]')
    if (!input) return
    if (disabled) {
      input.value = ""
      input.disabled = true
    } else {
      input.disabled = false
    }
  }
}
